import { useState } from "react";

export const ReadMore = ({ children, maxlength }) => {
  //taks a string as an argument like <p>sdasdas<p>
  const extractContent = (s) => {
    var span = document.createElement("span"); //this line wrap whole p tag into a span like(<span><p>dfadfsdf</p></span>)
    span.innerHTML = s;
    return span.textContent || span.innerText; // this return the content of span tag as a string
  };

  const text = extractContent(children);
  // console.log("text",text);

  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  return (
    <p style={{ color: children === "Removed" ? "red" : "black" }}>
      {isReadMore ? text.slice(0, maxlength) : text}
      <span
        onClick={toggleReadMore}
        className="readMore"
        style={{ color: "blue" }}
      >
        {children.length > maxlength
          ? isReadMore
            ? "...read more"
            : "   show less"
          : ""}
      </span>
    </p>
  );
};
